import React, { useMemo } from "react";
import { useAppContext } from "../../../contexts/AppContext";
import AirlineIdentity from "../components/AirlineIdentity";
import FareBadge from "../components/FareBadge";
import { resolveReviewAirlineIdentity } from "../review/resolveReviewAirlineIdentity";
import FlightLegDetails from "./FlightLegDetails";
import "./SelectedFlightOverview.css";

function airlineWithCatalogIdentity(airline, airlines) {
  if (!airline) return null;
  const identity = resolveReviewAirlineIdentity({
    airlines,
    code: airline.code || airline.logoText,
    fallbackName: airline.name,
  });
  const logo = identity.logoSrc || airline.logoUrl || airline.logo || null;
  return {
    ...airline,
    name: identity.name || airline.name,
    logo,
    logoUrl: logo,
  };
}

/** Unified Selected Flight Card: header + outbound + return. */
export default function SelectedFlightOverview({ offer }) {
  const { airlines } = useAppContext();
  const airline = useMemo(
    () => airlineWithCatalogIdentity(offer?.airline, airlines),
    [airlines, offer?.airline]
  );
  if (!offer) return null;
  return (
    <article className="fe2-selcard">
      <header className="fe2-selcard__head">
        <AirlineIdentity
          airline={airline}
          secondaryAirline={offer.secondaryAirline}
          size="lg"
          logoSrc={airline?.logoUrl || null}
        />
        <div className="fe2-selcard__badges">
          {(offer.fareBadges || []).map((b) => (
            <FareBadge key={b}>{b}</FareBadge>
          ))}
          {offer.fare?.cabin ? <FareBadge>{offer.fare.cabin}</FareBadge> : null}
          <span className="fe2-selcard__picked">נבחרה</span>
        </div>
      </header>

      <FlightLegDetails leg={offer.outbound} embedded />
      <div className="fe2-selcard__divider" aria-hidden />
      <FlightLegDetails leg={offer.inbound} embedded />
    </article>
  );
}
